import baseApi from './base.api'
import {
    clearAssignmentFilesQueryStarted,
    reviveAssignmentQueryStarted,
} from './utils/response-handlers/developer-mode.api.response-handlers'
import { ESCALATED_ANSWER_TAG, QUESTION_TAG, SUBMISSION_TAG } from './utils/tags'
import { normalizeEnterDeveloperMode } from './utils/normalizers/developer-mode.normalizers'

export const developerModeApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        enterDeveloperMode: builder.mutation({
            query: () => ({
                url: `/developer-mode/enter`,
                method: 'POST',
            }),
            transformResponse: normalizeEnterDeveloperMode,
        }),
        importQuestionDefinition: builder.mutation({
            query: ({ file, token, questionId }) => {
                const formData = new FormData()
                formData.append('file', file)

                return {
                    url: `/developer-mode/${token}/import-question-definition`,
                    method: 'POST',
                    params: {
                        question_id: questionId,
                    },
                    body: formData,
                }
            },
            invalidatesTags: [QUESTION_TAG],
        }),
        reviveAssignment: builder.mutation({
            query: ({ token }) => {
                return {
                    url: `/developer-mode/${token}/revive`,
                    method: 'POST',
                }
            },
            onQueryStarted: reviveAssignmentQueryStarted,
            invalidatesTags: [QUESTION_TAG],
        }),
        clearAssignmentFiles: builder.mutation({
            query: ({ token }) => {
                return {
                    url: `/developer-mode/${token}/clear-files`,
                    method: 'POST',
                }
            },
            onQueryStarted: clearAssignmentFilesQueryStarted,
            invalidatesTags: [QUESTION_TAG],
        }),
        revertToPostProjection: builder.mutation({
            query: ({ token }) => {
                return {
                    url: `/developer-mode/${token}/revert-to-post-projection`,
                    method: 'POST',
                }
            },
            invalidatesTags: [ESCALATED_ANSWER_TAG, SUBMISSION_TAG],
        }),
        exportQuestionDefinition: builder.query({
            query: ({ token, questionId }) => ({
                url: `/developer-mode/${token}/export-question-definition`,
                method: 'GET',
                body: {
                    response_format: 'json',
                },
                params: {
                    question_id: questionId,
                },
                responseType: 'blob',
            }),
        }),
        exportDetailedSubmissionPatterns: builder.query({
            query: ({ token }) => ({
                url: `/developer-mode/${token}/export-detailed-submission-patterns`,
                method: 'GET',
                body: {
                    response_format: 'csv',
                },
                responseType: 'blob',
            }),
        }),
    }),
})

export const {
    useLazyExportQuestionDefinitionQuery,
    useLazyExportDetailedSubmissionPatternsQuery,
    useImportQuestionDefinitionMutation,
    useReviveAssignmentMutation,
    useClearAssignmentFilesMutation,
    useRevertToPostProjectionMutation,
    useEnterDeveloperModeMutation,
} = developerModeApi
